/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { logoutTrigger } from '../../../actions'

/**
 * Import
 * - Selectors
 */
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Component Logout
 */
import Logout from '../../../components/pages/Logout/Logout'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
    }
}

export default connect(mapStateToProps, { logout: logoutTrigger })(Logout)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Logout/Logout.tsx